import { render, staticRenderFns } from "./CredenciamentoAtualizacaoEdital.vue?vue&type=template&id=b1f9a6f2"
import script from "./CredenciamentoAtualizacaoEdital.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoEdital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports